import styled from 'styled-components';

import { colors } from '../../../styles/theme';

const ContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 32px;
  max-width: 906px;
  width: 100%;
  height: 296px;
  margin: 0px;
  background: ${colors('white.base')};
  box-shadow: 0px 4px 10px 2px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
`;

export default ContainerStyles;
